import './menu.scss';
import logo from '../../assests/maarava_wide_icon.jpg';
import mainLogo from '../../assests/maarave-main-logo.jpg';
import React from "react";
import {ReactComponent as ShareIcon} from '../../assests/share-icon.svg';
import {ReactComponent as InfoIcon} from '../../assests/info-icon.svg';
import {ReactComponent as FeedbackIcon} from '../../assests/feedback-icon.svg';
import {ReactComponent as JoinUs} from '../../assests/business-man-icon.svg';
import {ReactComponent as FavoriteIcon} from '../../assests/star-icon.svg';
import config from '../../config/config'
import {sendWhatsAppMessage, shareApp} from '../../utils';
import { useHistory } from 'react-router-dom';
import {createAnalyticsEvent} from '../../firebase/firebase';


export default function Menu(props) {

    const {setOpen} = props;

    const history = useHistory();

    return (
        <div className={'app-menu-container'}>
            <div className={'app-menu-header'}>
                <img className={'logo-menu-header'} src={logo} alt={''}/>
            </div>
            <div className={'app-menu-body'}>
                <div className={'menu-item-container'} onClick={()=>{
                    createAnalyticsEvent({eventName: 'menu-item-share', eventParams: {click: true}});
                    shareApp();
                }}>
                    <ShareIcon className={'menu-item-icon'}/>
                    <div className={'menu-item-text'}>שיתוף</div>
                </div>
                <hr/>
                <div className={'menu-item-container'} onClick={()=>{
                    createAnalyticsEvent({eventName: 'menu-item-favorites', eventParams: {click: true}});
                    history.push('/favorites');
                    setOpen(false);
                }}>
                    <FavoriteIcon className={'menu-item-icon'}/>
                    <div className={'menu-item-text'}>המועדפים שלי</div>
                </div>
                <hr/>
                <div className={'menu-item-container'} onClick={()=>{
                    createAnalyticsEvent({eventName: 'menu-item-feedback', eventParams: {click: true}});
                    sendWhatsAppMessage({msg: '*פידבק על האפליקצייה של גוש מערבא:* : %0A', phoneNumber: config.appOwnerPhone})
                }}>
                    <FeedbackIcon className={'menu-item-icon'}/>
                    <div className={'menu-item-text'}>שלחו פידבק</div>
                </div>
                <hr/>
                <div className={'menu-item-container'} onClick={()=>{
                    createAnalyticsEvent({eventName: 'menu-item-join-us', eventParams: {click: true}});
                    sendWhatsAppMessage({msg: '*אנא מלא את הפרטים האלו, ושלח:* : %0A תחום עסק:%0A שם העסק:  %0A שם העסק(באנגלית): %0A שם בעל העסק: %0A מהם השירותים הניתנים במסגרת העסק ? %0A מילות חיפוש (מילים שיעזרו לחיפוש החופשי למצוא את העסק):%0A מיקום מתן השירות (בית העסק/בית הלקוח/משלוחים):%0A כתובת העסק: %0A שעות פעילות: %0A טלפון: %0A אתר אינטרנט: %0A עמוד אינסטגרם: %0A עמוד פייסבוק: %0A *אנא צרפ/י מיקום מדויק של בית העסק%0A  *אנא צרפ/י תמונה של לוגו של בית העסק שלך', phoneNumber: '+972525406220'})
                }}>
                    <JoinUs className={'menu-item-icon'}/>
                    <div className={'menu-item-text'}>הצטרפו אלינו!</div>
                </div>
                <hr/>
                <div className={'menu-item-container'} onClick={()=>{
                    createAnalyticsEvent({eventName: 'menu-item-info', eventParams: {click: true}});
                    history.push('/info');
                    setOpen(false);
                }}>
                    <InfoIcon className={'menu-item-icon'}/>
                    <div className={'menu-item-text'}>אודות האפליקצייה</div>
                </div>
            </div>
            <div className={'app-menu-main-logo-container'}>
                <img className={'app-menu-main-logo'} src={mainLogo} alt={''}/>
            </div>
            <div className={'app-menu-footer'}>app version: {config.version}</div>
        </div>
    );
}